import { isRouteErrorResponse, Link, useRouteError } from "react-router";
import { useTranslation } from "react-i18next";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { AlertTriangle, Compass } from "lucide-react";
import { Button, EmptyState } from "@pracownik/ui";
import { BrandLogo } from "./brand-logo";

export function RouteError() {
  const { t } = useTranslation("common");
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;

  useEffect(() => {
    if (!notFound) Sentry.captureException(error);
  }, [error, notFound]);

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <header className="mx-auto flex h-16 w-full max-w-7xl items-center px-4 sm:px-6">
        <BrandLogo />
      </header>
      <main className="flex flex-1 items-center justify-center px-4">
        <EmptyState
          size="page"
          icon={notFound ? <Compass /> : <AlertTriangle />}
          title={notFound ? t("errors.notFoundTitle") : t("errors.genericTitle")}
          description={notFound ? t("errors.notFoundBody") : t("errors.genericBody")}
          action={
            <>
              <Button asChild>
                <Link to="/dashboard">{t("errors.goDashboard")}</Link>
              </Button>
              {!notFound && (
                <Button variant="outline" onClick={() => window.location.reload()}>
                  {t("retry")}
                </Button>
              )}
            </>
          }
        />
      </main>
    </div>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation("common");
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <header className="mx-auto flex h-16 w-full max-w-7xl items-center px-4 sm:px-6">
        <BrandLogo />
      </header>
      <main className="flex flex-1 items-center justify-center px-4">
        <EmptyState
          size="page"
          icon={<Compass />}
          title={t("errors.notFoundTitle")}
          description={t("errors.notFoundBody")}
          action={
            <Button asChild>
              <Link to="/">{t("errors.goHome")}</Link>
            </Button>
          }
        />
      </main>
    </div>
  );
}
